import { ChangeDetectionStrategy, Component, inject } from '@angular/core'
import { BadgeComponent } from '@ftr/foundation'
import { PORTAL_BRANDING } from './portal-branding'

@Component({
  selector: 'ftr-portal-badge',
  templateUrl: './portal-badge.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [BadgeComponent],
})
export class PortalBadgeComponent {
  readonly portalBranding = inject(PORTAL_BRANDING)
}
